var storefrontApp = angular.module("storefrontApp");

storefrontApp.controller("categoriesController", [
    "$scope",
    "$rootScope",
    "$window",
    function ($scope, $rootScope,$window) {

        //#region Initialization
        $scope.searchCategory = "";
        $scope.$parent.enableScrollToTop = true;
        //#endregion

        $scope.initialize = function (prdType,fp) {
            $scope.prdType = prdType;
            $scope.fp= (fp.toLowerCase() === 'true');
            if($scope.prdType.toLowerCase() =='stockdesign'){
                $scope.displayPrdType = $scope.fp ? $rootScope.localeVariables.freeDesigns:$rootScope.localeVariables.designs;
            }
            else if($scope.prdType.toLowerCase() =='font'){
                $scope.displayPrdType = $rootScope.localeVariables.fonts;;
            }
            else if($scope.prdType.toLowerCase() === 'designpack'){
                $scope.displayPrdType = $rootScope.localeVariables.designPacks || 'Design Packs';
            }
            else if($scope.prdType.toLowerCase() === 'fontpack'){
                $scope.displayPrdType = $rootScope.localeVariables.fontPacks || 'Font Packs';
            }
            else{
                $scope.displayPrdType = prdType;
            }
            $scope.initializeCategories();
        };

        $scope.initializeCategories = function () {
            if (angular.isDefined($window.allCategories)) {
                $scope.allCategories = $window.allCategories.map(
                    $scope.normalizeCategory
                );
                $scope.browsableCategories = $scope.allCategories.filter(function (
                    category
                ) {
                    return category.isBrowsable;
                });
            }
            $scope.syncLandingSearchPlaceholder();
        };

        $scope.syncLandingSearchPlaceholder = function () {
            var input = $window.document.getElementById("searchCategory");
            if (!input) {
                return;
            }
            var full = input.getAttribute("data-placeholder-full");
            var short = input.getAttribute("data-placeholder-short");
            if (!full || !short) {
                return;
            }
            var isMobile = $window.matchMedia("(max-width: 767px)").matches;
            input.setAttribute("placeholder", isMobile ? short : full);
        };

        $scope.normalizeCategory = function (category) {
            return {
                categoryId: category.categoryId,
                parentCategoryId:
                    parseInt(category.parentCategoryId, 10) || 0,
                categoryName: category.categoryName || "",
                isTechnique:
                    category.isTechnique === true ||
                    String(category.isTechnique).toLowerCase() === "true",
                isBrowsable:
                    category.isBrowsable === true ||
                    String(category.isBrowsable).toLowerCase() === "true",
                itemCount: parseInt(category.itemCount, 10) || 0,
                parentCategoryName: category.parentCategoryName || "",
                definitionNames: category.definitionNames || "",
                imageUrl: category.imageUrl || "",
                listingsUrl: $scope.sanitizeCategoryUrl(category.listingsUrl || ""),
            };
        };

        $scope.sanitizeCategoryUrl = function (url) {
            if (!url || typeof url !== "string") {
                return "";
            }
            var trimmed = url.trim();
            if (
                trimmed.indexOf("://") !== -1 ||
                trimmed.indexOf("//") === 0 ||
                /^\s*javascript:/i.test(trimmed) ||
                /^\s*data:/i.test(trimmed)
            ) {
                return "";
            }
            return trimmed;
        };

        $scope.getCategorySearchResults = function () {
            if (
                !$scope.browsableCategories ||
                !$scope.searchCategory ||
                $scope.searchCategory.length <= 2
            ) {
                return [];
            }

            var term = $scope.searchCategory.toLowerCase().trim();
            return $scope.browsableCategories
                .filter(function (category) {
                    return (
                        category.categoryName
                            .toLowerCase()
                            .indexOf(term) !== -1
                    );
                })
                .sort(function (a, b) {
                    return a.categoryName.localeCompare(
                        b.categoryName,
                        undefined,
                        { sensitivity: "base" }
                    );
                });
        };
        //#endregion

        var syncPlaceholderOnResize = function () {
            $scope.syncLandingSearchPlaceholder();
        };
        angular.element($window).on("resize", syncPlaceholderOnResize);
        $scope.$on("$destroy", function () {
            angular.element($window).off("resize", syncPlaceholderOnResize);
        });
    }
]);
